import '@/styles/global.css';

import { ServerLayout } from '@crehana/layouts/ssr/layout.ssr';
import { useRuntimeContext } from '@modern-js/runtime';
import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';

import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import { Outlet, useParams } from '@/shared/modern-router';

const App = () => {
  const { slug, orgSlug } = useParams();
  const { context } = useRuntimeContext();

  return (
    <>
      <ServerLayout
        sentryInstance={Sentry}
        organizationSlug={(slug || orgSlug) as string}
        cookiesMap={context.request.cookieMap}
      >
        <NuqsAdapter>
          <Outlet />
          <AddBaseFunctionality />
        </NuqsAdapter>
      </ServerLayout>
    </>
  );
};

export default App;
